<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="EMPRESAS CONVENIADAS" :data="searchedData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="3" :totalPDF="total" :titleReport="titleReport" :btnHide="btnHide">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
                <md-button v-if="btnHide" class="md-button md-site md-just-icon md-round" :to="{ name: 'Dashboard' }">
                    <md-icon>dashboard</md-icon>
                    <md-tooltip md-direction="top">Dashboard</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-30 md-xsmall-size-100 ml-auto">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="EMPRESA" style="width: 30%" md-sort-by="nome">{{ item.empresa }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="TELEFONES" style="width: 22%" md-sort-by="cpf_cnpj">{{ item.contatos }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="ENDEREÇO" style="width: 38%" md-sort-by="empresa">{{ item.endereco}} </md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item @click="visualizar(item.id)">
                                        VISUALIZAR<md-icon class="text-info">visibility</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>

    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import Swal from "sweetalert2";

export default {
    name: 'NiveisAcessoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {
                situacao_id: 1
            },
            detalhes: {},
            permissoes: this.$store.state.usuario.permissao,
            titleReport: 'Empresas Conveniadas.',
            columnsPDF: [60, 30, 90],
            headRowsPDF: ['EMPRESA', 'CONTATO', 'ENDEREÇO'],
            bodyRowsPDF: ['empresa', 'contatos', 'endereco'],
            fildsTXT: ['id', 'empresa', 'telefone', 'celular', 'endereco'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "EMPRESA",
                    field: "empresa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "TELEFONE",
                    field: "telefone"
                },
                {
                    label: "CELULAR",
                    field: "celular"
                },
                {
                    label: "ENDEREÇO",
                    field: "endereco",
                    dataFormat: this.upperCaseFormat
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            btnHide: false
        };
    },

    created () {
        //oculta o botão de opções
        if(this.$store.state.usuario.niveis[0].id == 6){
            this.btnHide = true
        };
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.$http.get(this.$urlAPI + 'empresas/conveniadas')
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower(
                    [item.empresa, item.razao, item.endereco, item.grupo, item.seguimento]
                ).includes(this.toLower(term)))
            }
            return items
        },

        visualizar(id) {
            this.$router.push({
                name: 'fornecedorView',
                params: {
                    id: id
                }
            })
        }
    },
};
</script>
